<section class="playground">
  <h2 class="playground__heading">Text area (Froala)</h2>

  <p class="playground__hint playground__doc-ref">
    Editor enriquecido simplificado (Froala), alineado al DS. Toolbar: negrita, cursiva, listas y enlaces.
    <code>valueFormat="plain"</code> guarda texto plano en el FormControl; <code>html</code> guarda HTML (avisos).
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>valueFormat</span>
        <select [(ngModel)]="valueFormat">
          <option *ngFor="let vf of valueFormats" [ngValue]="vf">{{ vf }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>widthLayout</span>
        <select [(ngModel)]="widthLayout">
          <option *ngFor="let w of widthLayouts" [ngValue]="w">{{ w }}</option>
        </select>
      </label>
      <label class="playground__field" *ngIf="widthLayout === 'ds'">
        <span>maxWidth (opcional)</span>
        <input type="text" [(ngModel)]="maxWidthCustom" placeholder="Ej. 400px o vacío = 292px" />
      </label>
      <label class="playground__field">
        <span>label</span>
        <input type="text" [(ngModel)]="label" />
      </label>
      <label class="playground__field">
        <span>placeholder</span>
        <input type="text" [(ngModel)]="placeholder" />
      </label>
      <label class="playground__field">
        <span>hint</span>
        <input type="text" [(ngModel)]="hint" />
      </label>
      <label class="playground__field">
        <span>minHeightPx</span>
        <input type="number" [(ngModel)]="minHeightPx" min="80" />
      </label>
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="hasCharacterCounter" />
        <span>hasCharacterCounter</span>
      </label>
      <label class="playground__field">
        <span>maxCharacters (null = sin “/ máx.”)</span>
        <select [(ngModel)]="maxCharacters">
          <option [ngValue]="500">500</option>
          <option [ngValue]="2000">2000</option>
          <option [ngValue]="null">null (solo total)</option>
        </select>
      </label>
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="successful" />
        <span>successful</span>
      </label>
    </div>

    <div>
      <p class="playground__preview-title">Vista previa (FormControl)</p>
      <p class="playground__section-hint">
        Inspecciona <code>descriptionControl.value</code>: string plano o HTML según <code>valueFormat</code>.
      </p>
      <div class="playground__preview-box playground__preview-box--modal">
        <app-text-area-field
          [control]="descriptionControl"
          [valueFormat]="valueFormat"
          [widthLayout]="widthLayout"
          [maxWidth]="widthLayout === 'ds' && maxWidthCustom ? maxWidthCustom : undefined"
          [label]="label"
          [placeholder]="placeholder"
          [hint]="hint"
          [minHeightPx]="minHeightPx"
          [hasCharacterCounter]="hasCharacterCounter"
          [maxCharacters]="maxCharacters"
          [disabled]="disabled"
          [successful]="successful"
          [errorMessages]="{ required: 'La descripción es obligatoria' }"
        ></app-text-area-field>
        <button type="button" class="playground__btn" (click)="markTouched()">Marcar touched (error)</button>
      </div>
    </div>
  </div>
</section>
